import {useEffect,useState} from 'react';
import {
  Stack,
  Container,
} from '@mui/material';
// components
import Page from '../components/Page';
import axios from 'axios';
import {API_URL, ECHARGEUP_ID, RELATION_TYPE} from '../constant';
import {useNavigate, useParams} from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { includes, isEmpty } from 'lodash';
import LoadingSpinner from './LoadingSpinner'
import DetailCard from './DetailCard';
import ExtraDocumment from './ExtraDocument';
import AddMemberModal from './AddMembers';
import PdcChequeDialog from './PdcChequeDetails';
import TvrForm from './TvrDetails'
import FiForm from './FiForm';
import TvrList from './TvrList';


const styles = {
  tooltip: {
      maxWidth:'max-content',
      backgroundColor: "black"
  }
};

export default function StatusPage() {
  const{id}=useParams()
  const [applicantDetail,setApplicantDetail] = useState([]);
  const [memberDetail,setMemberDetail] = useState([]);
  const [loanId,setLoanId] = useState(id);
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const [openPdc, setOpenPdc] = useState(false);
  const [openFiForm, setOpenFiForm] = useState(false);
  const [openTvrForm, setOpenTvrForm] = useState(false);
  
  const [editMember, setEditMember] = useState({});
  const [tvrList, setTvrList] = useState({});



  const handelAddMember = () => setOpen(true);
  const handlePdcCheque = () => setOpenPdc(true);
  const handleTvrForm = () => setOpenTvrForm(true);
  const handleFiForm = () => setOpenFiForm(true);

  const handleClose = () => {
    setOpen(false)
    setOpenPdc(false)
    setOpenFiForm(false)
    setOpenTvrForm(false)
  };

  // const handleEdit = (value) => {
  //   setEditMember(value);
  //   setOpen(true);
  // };

 
  useEffect(() => {
    if(loanId){
      getLeadData()
      getTvrDetails()
    }
  },[loanId]);

  const getTvrDetails=async()=>{
    const result= await axios.get(`${API_URL}/loan/${loanId}/tvr`)
    setTvrList(result?.data?.data);
  }

  async function getLeadData() {
    setOpen(false)
    const res = await axios.get(`${API_URL}/leads/${loanId}`);
    if(res?.data?.data){
      const leadData = res?.data?.data
      setApplicantDetail(leadData?.applicant);
      setMemberDetail(leadData?.relations);
      setLoading(false)
    }
  }

  const CUSTOMER_DETAIL = {
    TITLE : 'Customer Details',
    BODY : [
      { name: "Loan ID", key: "loan_id" },
      { name: "Lead Type", key: "type" },
      { name: "Loan State", key: "state" },
      { name: "Name", key: "name" },
      { name: "Mobile", key: "mobile" },
      { name: "Address", key: "customer_address" },
      { name: "Sanctioned Amount", key: "sanctioned_amount" },
      { name: "EMI", key: "emi" },
      { name: "Tenure", key: "tenure" },
    ]
  }

  const RELATION_DETAILS = {
    TITLE : 'relation' + ' Details',
    BODY : [
      { name: "Name", key: "name" },
      { name: "Mobile", key: "mobile" },
      { name: "Relation Type", key: "relation_type" },
      { name: "Relation", key: "relation" },
    ] 
  }

  return (
    <Page>
      {loading ? <LoadingSpinner /> : <Container maxWidth>
        {/* Header Component */}
          {/* Buttons Container */}
          {(ECHARGEUP_ID,applicantDetail?.dealer_id) && <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            flexWrap="wrap"
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              mt:1,
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2,
            }}
          >
            <h1 style={{ fontFamily: 'sans-serif', fontWeight:'lighter'}}>Loan -{applicantDetail?.loan_id}</h1>
            <div style={{display:'flex', justifyContent:'center', gap:20}}>
              {/* ADD LOAN MEMBER */}
              <div>
                <LoadingButton
                  size="medium"
                  color="secondary"
                  variant="contained"
                  onClick={handelAddMember} // Opens modal
                >
                  <i className="bi bi-person-plus" style={{ paddingRight: "10px" }}></i>
                  Add Members
                </LoadingButton>

                {/* Modal Component */}
                {open && <AddMemberModal open={open} onClose={handleClose} onSubmit={getLeadData} editData={editMember} loanData= {{loan_id: applicantDetail.loan_id, customer_id:applicantDetail.customer_id}}/>}
              </div>
              
              {/* ADD PDC CHEQUE */}
              <div>
                {/* Use LoadingButton to open modal */}
                <LoadingButton
                  size="medium"
                  color="secondary"
                  variant="contained"
                  onClick={handlePdcCheque} // Opens modal
                >
                  <i className="bi bi-file-earmark-text" style={{ paddingRight: "10px" }}></i>
                  Add Pdc Cheque
                </LoadingButton>

                {/* Modal Component */}
                {openPdc && <PdcChequeDialog  open={openPdc} onClose={handleClose} data={[...memberDetail, applicantDetail]} />}
                
              </div>

              {/* ADD FI-FORM */}
              <div>
                {/* Use LoadingButton to open modal */}
                <LoadingButton
                  size="medium"
                  color="secondary"
                  variant="contained"
                  onClick={handleFiForm} // Opens modal
                >
                  <i className="bi bi-journal-text" style={{ paddingRight: "10px" }}></i>
                  Add Fi Form
                </LoadingButton>

                {/* Modal Component */}
                {openFiForm && <FiForm open={openFiForm} onClose={handleClose} data={{loan_id: applicantDetail.loan_id}} />}
              </div>
              
              {/* ADD TVR FORM */}
              <div>
                {/* Use LoadingButton to open modal */}
                <LoadingButton
                  size="medium"
                  color="secondary"
                  variant="contained"
                  onClick={handleTvrForm} // Opens modal
                >
                  <i className="bi bi-file" style={{ paddingRight: "10px" }}></i>
                  Tvr Form
                </LoadingButton>

                {/* Modal Component */}
                {openTvrForm && <TvrForm  open={openTvrForm} onClose={handleClose} data={[...memberDetail, applicantDetail]} />}
                
              </div>
            </div>
          </Stack>}

          {/* CustomerStat */}

          {!isEmpty(applicantDetail) && <DetailCard
            onSuccess={getLeadData} 
            title={CUSTOMER_DETAIL.TITLE}
            data={CUSTOMER_DETAIL.BODY}
            details={applicantDetail}
            rows={4}
          />}

          {/* Document Details */}
          {!isEmpty(applicantDetail) && <ExtraDocumment details={applicantDetail} onSuccess={getLeadData}/>}

          {/* Tvr List */}

          {!!tvrList && <TvrList data={tvrList}/>}

          {/* Members */}
          {!isEmpty(memberDetail) && memberDetail.map(member => (
            <>
            <DetailCard
              onSuccess={getLeadData}
              title={RELATION_DETAILS.TITLE?.replace('relation', member.relation_type.charAt(0).toUpperCase() + member.relation_type.slice(1))}
              data={RELATION_DETAILS.BODY}
              details={member}
              rows={3}
              />
              {/* Document Details */}
              {includes([RELATION_TYPE.GUARANTOR, RELATION_TYPE.COAPPICANT],member.relation_type) && <ExtraDocumment details={member} onSuccess={getLeadData}/>}
            {/* <LoadingButton
                size="medium"
                color="secondary"
                variant="contained"
                onClick={() => handleEdit(member)} // Opens modal
              >
                <i className="bi bi-person-plus" style={{ paddingRight: "10px" }}></i>
                Edit Members
              </LoadingButton> */}
              </>
          ))}

      </Container>}
    </Page>
  );
}